module.exports = __webpack_public_path__ + "img/signIn_icon2.94be3bd6.png";